/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RewardCategory } from './RewardCategory';
import {
    RewardCategoryFromJSON,
    RewardCategoryFromJSONTyped,
    RewardCategoryToJSON,
} from './RewardCategory';
import type { RewardOrigin } from './RewardOrigin';
import {
    RewardOriginFromJSON,
    RewardOriginFromJSONTyped,
    RewardOriginToJSON,
} from './RewardOrigin';
import type { PlayerRewardStatus } from './PlayerRewardStatus';
import {
    PlayerRewardStatusFromJSON,
    PlayerRewardStatusFromJSONTyped,
    PlayerRewardStatusToJSON,
} from './PlayerRewardStatus';

/**
 * 
 * @export
 * @interface PlayerRewardWithOrigin
 */
export interface PlayerRewardWithOrigin {
    /**
     * 
     * @type {PlayerRewardStatus}
     * @memberof PlayerRewardWithOrigin
     */
    status: PlayerRewardStatus;
    /**
     * 
     * @type {Date}
     * @memberof PlayerRewardWithOrigin
     */
    createdAt: Date;
    /**
     * 
     * @type {object}
     * @memberof PlayerRewardWithOrigin
     */
    rewardMeta: object;
    /**
     * 
     * @type {RewardCategory}
     * @memberof PlayerRewardWithOrigin
     */
    rewardCategory: RewardCategory;
    /**
     * 
     * @type {string}
     * @memberof PlayerRewardWithOrigin
     */
    rewardTypeId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PlayerRewardWithOrigin
     */
    spinId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PlayerRewardWithOrigin
     */
    playerId: string;
    /**
     * 
     * @type {string}
     * @memberof PlayerRewardWithOrigin
     */
    customerId: string;
    /**
     * 
     * @type {string}
     * @memberof PlayerRewardWithOrigin
     */
    id: string;
    /**
     * Ticket scan that triggered the promotion which issued this reward. Absent for non-promotion rewards.
     * @type {string}
     * @memberof PlayerRewardWithOrigin
     */
    triggeringScanId?: string | null;
    /**
     * Message from the most recent assignment attempt, e.g. the failure reason for FAILED rewards.
     * @type {string}
     * @memberof PlayerRewardWithOrigin
     */
    latestAttemptMessage?: string | null;
    /**
     * 
     * @type {RewardOrigin}
     * @memberof PlayerRewardWithOrigin
     */
    origin: RewardOrigin;
}



/**
 * Check if a given object implements the PlayerRewardWithOrigin interface.
 */
export function instanceOfPlayerRewardWithOrigin(value: object): value is PlayerRewardWithOrigin {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('rewardMeta' in value) || value['rewardMeta'] === undefined) return false;
    if (!('rewardCategory' in value) || value['rewardCategory'] === undefined) return false;
    if (!('playerId' in value) || value['playerId'] === undefined) return false;
    if (!('customerId' in value) || value['customerId'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('origin' in value) || value['origin'] === undefined) return false;
    return true;
}

export function PlayerRewardWithOriginFromJSON(json: any): PlayerRewardWithOrigin {
    return PlayerRewardWithOriginFromJSONTyped(json, false);
}

export function PlayerRewardWithOriginFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlayerRewardWithOrigin {
    if (json == null) {
        return json;
    }
    return {
        
        'status': PlayerRewardStatusFromJSON(json['status']),
        'createdAt': (new Date(json['createdAt'])),
        'rewardMeta': json['rewardMeta'],
        'rewardCategory': RewardCategoryFromJSON(json['rewardCategory']),
        'rewardTypeId': json['rewardTypeId'] == null ? undefined : json['rewardTypeId'],
        'spinId': json['spinId'] == null ? undefined : json['spinId'],
        'playerId': json['playerId'],
        'customerId': json['customerId'],
        'id': json['id'],
        'triggeringScanId': json['triggeringScanId'] == null ? undefined : json['triggeringScanId'],
        'latestAttemptMessage': json['latestAttemptMessage'] == null ? undefined : json['latestAttemptMessage'],
        'origin': RewardOriginFromJSON(json['origin']),
    };
}

export function PlayerRewardWithOriginToJSON(value?: PlayerRewardWithOrigin | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'status': PlayerRewardStatusToJSON(value['status']),
        'createdAt': ((value['createdAt']).toISOString()),
        'rewardMeta': value['rewardMeta'],
        'rewardCategory': RewardCategoryToJSON(value['rewardCategory']),
        'rewardTypeId': value['rewardTypeId'],
        'spinId': value['spinId'],
        'playerId': value['playerId'],
        'customerId': value['customerId'],
        'id': value['id'],
        'triggeringScanId': value['triggeringScanId'],
        'latestAttemptMessage': value['latestAttemptMessage'],
        'origin': RewardOriginToJSON(value['origin']),
    };
}

